import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["form", "qcRouteInput"];
  static values = { createUrl: String };

  connect() {
    this.boundHandler = this.handleQcRouteSelected.bind(this);
    window.addEventListener('qc-route-selected', this.boundHandler);
  }

  disconnect() {
    window.removeEventListener('qc-route-selected', this.boundHandler);
  }

  handleQcRouteSelected(event) {
    const qcRoute = event.detail.qcRoute;
    if (this.hasQcRouteInputTarget) {
      this.qcRouteInputTarget.value = qcRoute;
    }

    if (this.hasCreateUrlValue) {
      this.formTarget.action = this.createUrlValue;
    }

    this.formTarget.requestSubmit();
  }
}
